import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { midaPageRoutes } from './mida-page/mida-page.routes';
import { AuthGuard } from './shared/core/guard/auth.guard';
import { loadPermissionsGuard } from './shared/core/guard/permission.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'reset-password/:token',
    loadComponent: () => import('./reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'password/:userUuid',
    loadComponent: () => import('./new-password/new-password.component').then((m) => m.NewPasswordComponent),
  },
  {
    path: 'm',
    canActivate: [AuthGuard, loadPermissionsGuard],
    loadComponent: () => import('./mida-page/mida-page.component').then((m) => m.MidaPageComponent),
    children: midaPageRoutes,
  },
  {
    path: 'loan-tokenisation/:loanRef',
    loadComponent: () =>
      import('./collect/components/loans/components/loan-details/components/loan-tokenisation/loan-tokenisation.component').then((m) => m.LoanTokenisationComponent),
  },
  {
    path: 'paygate/gateway/:loanRef',
    loadComponent: () =>
      import('./collect/components/loans/components/loan-details/components/loan-tokenisation/paygate/paygate-wizard.component').then((m) => m.PaygateWizardComponent),
  },
  {
    path: 'payment-details/:loanUuid',
    loadComponent: () =>
      import('./payment-details/payment-details.component').then((m) => m.PaymentDetailsComponent),
  },

  { path: '', redirectTo: 'login', pathMatch: 'full' },
];
